import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"calendar\"><g id=\".fill\" clip-path=\"url(#clip0)\"><path id=\"Vector\" d=\"M7.375 16.375H11.125C11.4688 16.375 11.75 16.0938 11.75 15.75V12C11.75 11.6562 11.4688 11.375 11.125 11.375H7.375C7.03125 11.375 6.75 11.6562 6.75 12V15.75C6.75 16.0938 7.03125 16.375 7.375 16.375ZM18.625 4.5H16.75V2.625C16.75 2.28125 16.4688 2 16.125 2H14.875C14.5312 2 14.25 2.28125 14.25 2.625V4.5H9.25V2.625C9.25 2.28125 8.96875 2 8.625 2H7.375C7.03125 2 6.75 2.28125 6.75 2.625V4.5H4.875C3.83984 4.5 3 5.33984 3 6.375V20.125C3 21.1602 3.83984 22 4.875 22H18.625C19.6602 22 20.5 21.1602 20.5 20.125V6.375C20.5 5.33984 19.6602 4.5 18.625 4.5ZM18.625 19.8906C18.625 20.0195 18.5195 20.125 18.3906 20.125H5.10938C4.98047 20.125 4.875 20.0195 4.875 19.8906V8.25H18.625V19.8906Z\"></path></g></g><defs><clipPath id=\"clip0\"><rect width=\"17.5\" height=\"20\" transform=\"translate(3 2)\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }